import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon--svg icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.25 4.5V16.6269L5.55386 10.9308L4.50003 12L12 19.5L19.5 12L18.4462 10.9308L12.75 16.6269V4.5H11.25Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }